// extracted by mini-css-extract-plugin
module.exports = {"katexContainer":"Katex_katexContainer__Pub3W"};